<modal #securityModal
[(errorMessage)]="_errorMessageAuth"
id="securityModal"
[submitButtonText]="_appService.CoreCommonLiterals?.ButtonConfirm"
(onSubmit)="modalExecuteAction()"
[closeButtonText]="_appService.CoreCommonLiterals?.ButtonCancel"
(onClose)="close()"
>
  <modal-header>
    {{actions?.Description ? actions?.Description : _appService.CoreCommonLiterals?.ChangeValue}}
  </modal-header>
  <modal-content>
    <div *ngIf="actions">
      <form #formElement="ngForm" autocomplete="off">
        <div class="mb-3 text-center" *ngIf="actions && actions?.ConfirmationMessage" >
          <div class="text-center text-warning w-100 mb-2">
            <i class="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i>
          </div>
          <label>{{actions.ConfirmationMessage ? actions.ConfirmationMessage : ''}}</label>
        </div>
        <div class="row">
          <div class="form-group col-sm" *ngIf="actions && actions?.ActionType === displayClusterActionType.SetScalarValue" [ngClass]="{'col-sm-6': actions?.ActionType === displayClusterActionType.SetScalarValue}">
            <label for="changeValue">{{_appService.CoreCommonLiterals?.Value}}</label>
            <input
              type="number"
              [(ngModel)]="changeValue"
              (click)="_errorMessageAuth=''"
              class="form-control"
              id="changeValue"
              name="changeValue"
              pattern="^[+-]?\d+(\.\d+)?$"
              required
            />
          </div>
          <div class="form-group col-12" *ngIf="actions && actions?.ActionType === displayClusterActionType.SetDiscreteValue">
            <custom-select
              [(ngModel)]="discreteValue"
              [bordered]="true"
              [keepValueIfExistsInNewList]="true"
              [labelText]="_appService.CoreCommonLiterals.Value"
              name="changeValue"
              id="changeValue"
            [(sourceList)]="discreteValueList">
            </custom-select>
          </div>
          <div class="form-group col-sm" *ngIf="actions && actions?.ActionType === displayClusterActionType.SetScalarValue" [ngClass]="{'col-sm-6': actions?.ActionType === displayClusterActionType.SetScalarValue}">
            <label for="unitValue">&nbsp;</label>
            <custom-select
              [(ngModel)]="unitValue"
              [bordered]="true"
              [keepValueIfExistsInNewList]="true"
              name="unitValue"
              id="unitValue"
            [(sourceList)]="unitValueList">
            </custom-select>
          </div>
        </div>
        <div class="form-group" *ngIf="actions && actions?.ActionType === displayClusterActionType.Simple && actions.CurrentValue !== null">
          <label for="changeTextValue">{{_appService.CoreCommonLiterals?.Content}}</label>
          <textarea
            type="text" 
            customFocus 
            maxlength="255"
            name="changeTextValue" 
            [(ngModel)]="changeValueText"
            (click)="_errorMessageAuth=''"
            class="form-control" 
            id="changeTextValue" 
            [placeholder]="_appService.CoreCommonLiterals?.Content"
            required
            style="min-height: 75px;"
          ></textarea>
        </div>
        <div class="alert alert-info col-sm-12" *ngIf="unitValue && unitValueList.length > 1">{{_appService.CoreCommonLiterals.AlertInfoUnitValue | replaceLiterals:[alertInfoUnitValue]}}</div>
        <div class="form-group" *ngIf="!hidePassword && actions && actions?.RequiresPasswordConfirmation">
          <label for="password">{{_appService.CoreCommonLiterals?.Password}}</label>
          <input
            type="password"
            autocomplete="new-password"
            (click)="_errorMessageAuth=''"
            [(ngModel)]="password"
            class="form-control"
            id="password"
            name="password"
            required
          />
        </div>
      </form>
    </div>
    <div class="text-center my-3" *ngIf="pageStatus === 0">
      <i class="fas fa-circle-notch fa-spin fa-2x"></i>
    </div>
  </modal-content>
</modal>
